module.exports = __webpack_public_path__ + "img/Frage2_768x1024.f2e13f68.jpg";